import { TranslatableText } from '@dreryk/react-common';

import { appointmentsTranslationKeys } from '../../translations';

export const MEDICAL_PROFILE_GENERAL_TEMPLATE_CODE = 'MEDICAL_PROFILE_GENERAL';
export const MEDICAL_PROFILE_NEUROLOGY_TEMPLATE_CODE = 'MEDICAL_PROFILE_NEUROLOGY';

export type MedicalProfileTemplateEntry = {
   readonly templateCode: string;
   readonly tabLabel: TranslatableText;
};

export const MEDICAL_PROFILE_TEMPLATE_CODE_LIST: MedicalProfileTemplateEntry[] = [
   {
      templateCode: MEDICAL_PROFILE_GENERAL_TEMPLATE_CODE,
      tabLabel: appointmentsTranslationKeys.medicalProfile.tabs.general,
   },
   {
      templateCode: MEDICAL_PROFILE_NEUROLOGY_TEMPLATE_CODE,
      tabLabel: appointmentsTranslationKeys.medicalProfile.tabs.neurology,
   },
];
